import { queryOptions } from "@tanstack/react-query"
import { encountersKeys } from "./keys"
import { handleApiError, handleResponse } from "~/utils/response"
import { AppointmentByIdResponse } from "../types"
import { apiClient } from "~/lib/client"

interface AppointmentsByIdQueryOptions {
    id: string
}

export const getAppointmentsByIdQueryOptions = (opts: AppointmentsByIdQueryOptions) => {
    return queryOptions({
        queryKey: encountersKeys.appointmentsById(opts),
        retry: false,
        queryFn: async () => {
            try {
                const response = await apiClient(`/admin/appointments/${opts.id}`)
                const result = await handleResponse<AppointmentByIdResponse>(response)

                if (!result.success) {
                    throw new Error(result.error)
                }

                return result.data
            } catch (error) {
                handleApiError(error)
                throw error
            }
        },
        enabled: !!opts.id,
        select(data) {
            return {
                id: data.appointment.appointment_id,
                description: `${data.appointment.title}`,
                location: data.appointment.location ?? "Zoom",
                patient: {
                    name: data.appointment.patient.name,
                    email: data.appointment.patient.email ?? "ekomobongmarcus20@gmail.com",
                    age: data.appointment.patient.age,
                    gender: data.appointment.patient.gender,
                    patient_id: data.appointment.patient.user_id,
                },
                meetingLink: data.appointment.zoom_metadata?.join_url ?? "",
                timezone: data.appointment.zoom_metadata?.timezone ?? "Africa/Lagos",
                meetingCreatedAt: `${formatDate(data.appointment.zoom_metadata?.created_at ?? "", "datetime")}`,
                type: data.appointment.type,
                status: data.appointment.status,
                meetingStartingTime: formatDate(`${data.appointment.appointment_datetime}`, "datetime"),
            }
        }
    })
}